import { COLORS } from "components/consts";
import { SxProps } from "@mui/material";

export const commonStyles: SxProps = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 572,
  height: 338,
  bgcolor: COLORS.white,
  borderRadius: "16px",
};

export const collectorModalStyle: SxProps = {
  ...commonStyles,
  width: 572,
  height: 763,
};

export const siteSelectorStyle: SxProps = {
  ...commonStyles,
  width: 572,
  height: 338,
};

export const textFieldSizeStyle: SxProps = {
  width: "100%",
  mt: "8px",
  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: COLORS.Romance,
  },
  "&:hover .MuiOutlinedInput-notchedOutline": {
    borderColor: COLORS.Romance,
  },
  "& .MuiInputBase-root": {
    height: "36px",
    borderRadius: "8px",
    fontSize: 14,
    padding: 0,
    fontWeight: 500,
    color: COLORS.Romance,
  },
};